module.exports = __webpack_public_path__ + "img/boy-test-landing.cf5b745a.png";